import ApiService from "@/common/api.service"
import * as action from "@/store/action.types"
import * as mutation from "@/store/mutation.types"
import _ from "lodash"
import {
  FETCH_CALENDAR_ACTIVITY_DATA_URL,
  // UPLOAD_ACTIVITY_ATTACHMENT_URL,
  // DELETE_ACTIVITY_ATTACHMENT_URL,
  DELETE_ACTIVITY_SESSION_URL,
  CHANGE_ACTIVITY_DESCRIPTION_URL,
  GET_ACTIVITY_SEGMENTS_URL,
  CREATE_ACTIVITY_SEGMENTS_URL,
  DELETE_ACTIVITY_SEGMENTS_URL,
  GET_SEGMENTS_STATS_TABLE_URL,
  GET_MORE_PRECISE_ACTIVITY_DATA_URL,
  GET_TIMELINE_CHART_DATA_URL,
} from "@/constants/ApiConstants"
import {
  SESSION_METRICS,
  TIME_ABOVE_80_PERCENT_HR_UNITS,
  AP_ZONES_UNITS,
  WORKLOAD_ZONES_UNITS,
  DISTANCE_ZONES_UNITS,
  SEGMENT_METRICS,
} from "@/constants/SessionConsts"
import moment from "moment"
import { METRICS } from "@/constants/DashboardConstants"

const getDefaultState = () => ({
  info: null,
  stats: {
    [SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR]: null,
    [SESSION_METRICS.AP]: null,
    [SESSION_METRICS.DISTANCE]: null,
    [SESSION_METRICS.WORKLOAD]: null,
  },
  summary: null,
  playerActivityId: null,
  dataFetchedSuccessfully: false,
  selectedMetric: SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR,
  hrSelectedUnit: TIME_ABOVE_80_PERCENT_HR_UNITS.PERCENTAGE,
  avgHrSelectedUnit: TIME_ABOVE_80_PERCENT_HR_UNITS.PERCENTAGE,
  topHrSelectedUnit: TIME_ABOVE_80_PERCENT_HR_UNITS.PERCENTAGE,
  apZonesSelectedUnit: AP_ZONES_UNITS.PERCENTAGE,
  workloadZonesSelectedUnit: WORKLOAD_ZONES_UNITS.PERCENTAGE,
  distanceZonesSelectedUnit: DISTANCE_ZONES_UNITS.PERCENTAGE,
  hrChartUnit: TIME_ABOVE_80_PERCENT_HR_UNITS.PERCENTAGE,
  distanceChartUnit: DISTANCE_ZONES_UNITS.PERCENTAGE,
  activityDeleted: false,
  segments: [],
  filteredSegments: [],
  statsSegment: {
    [SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR]: [],
    [SESSION_METRICS.AP]: [],
    [SESSION_METRICS.DISTANCE]: [],
    [SESSION_METRICS.WORKLOAD]: [],
  },
  mediumPreciseChartDataHrPercentage: {},
  mediumPreciseChartDataHrBPM: {},
  highPreciseChartDataHrBPM: {},
  highPreciseChartDataHrPercentage: {},
  highestPreciseChartDataHrBPM: {},
  highestPreciseChartDataHrPercentage: {},
  mediumPreciseChartDataAP: {},
  highPreciseChartDataAP: {},
  highestPreciseChartDataAP: {},
  activityNotFound: false,
  activityDeleted: false,
  timelineChartData: null,
})

const state = {
  ...getDefaultState(),
  cachedActivities: [],
}

const getters = {
  activityInfo: (state) => state.info,
  activityStats: (state) => state.stats,
  activitySummary: (state) => state.summary,
  activityAttachments: (state) => (state.info ? state.info.attachments : null),
  description: (state) => (state.info ? state.info.description : null),
  playerActivityId: (state) => state.playerActivityId,
  activityDataFetchedSuccessfully: (state) => state.dataFetchedSuccessfully,
  calendarActivityselectedMetric: (state) => state.selectedMetric,
  hrSelectedUnit: (state) => state.hrSelectedUnit,
  avgHrSelectedUnit: (state) => state.avgHrSelectedUnit,
  topHrSelectedUnit: (state) => state.topHrSelectedUnit,
  apZonesSelectedUnit: (state) => state.apZonesSelectedUnit,
  workloadZonesSelectedUnit: (state) => state.workloadZonesSelectedUnit,
  distanceZonesSelectedUnit: (state) => state.distanceZonesSelectedUnit,
  hrChartUnit: (state) => state.hrChartUnit,
  distanceChartUnit: (state) => state.distanceChartUnit,
  activityDeleted: (state) => state.activityDeleted,
  segments: (state) => state.segments,
  filteredSegments: (state) => state.filteredSegments,
  statsSegment: (state) => state.statsSegment,
  mediumPreciseChartDataHrPercentage: (state) =>
    state.mediumPreciseChartDataHrPercentage,
  mediumPreciseChartDataHrBPM: (state) => state.mediumPreciseChartDataHrBPM,
  highPreciseChartDataHrBPM: (state) => state.highPreciseChartDataHrBPM,
  highPreciseChartDataHrPercentage: (state) =>
    state.highPreciseChartDataHrPercentage,
  highestPreciseChartDataHrBPM: (state) => state.highestPreciseChartDataHrBPM,
  highestPreciseChartDataHrPercentage: (state) =>
    state.highestPreciseChartDataHrPercentage,
  mediumPreciseChartDataAP: (state) => state.mediumPreciseChartDataAP,
  highPreciseChartDataAP: (state) => state.highPreciseChartDataAP,
  highestPreciseChartDataAP: (state) => state.highestPreciseChartDataAP,
  activityNotFound: (state) => state.activityNotFound,
  activityDeleted: (state) => state.activityDeleted,
  timelineChartData: (state) => state.timelineChartData,
}

const actions = {
  [action.FETCH_CALENDAR_ACTIVITY_DATA](
    { commit, state, dispatch },
    { activityId }
  ) {
    return new Promise((reject, resolve) => {
      activityId = parseInt(activityId)

      const activityData = state.cachedActivities.filter(
        (a) => a.playerActivityId === activityId
      )
      if (activityData.length) {
        commit(mutation.SET_CALENDAR_ACTIVITY, activityData[0])
        dispatch(action.FETCH_TIMELINE_CHART_DATA, {
          playerId: state.info.playerId,
          metric:
            state.selectedMetric === "AP"
              ? "AP_PERCENTAGE"
              : state.selectedMetric,
          toDate: moment(state.info.ended).format("YYYY-MM-DD"),
        })
        return resolve(activityData[0])
      } else {
        ApiService.get(
          `${FETCH_CALENDAR_ACTIVITY_DATA_URL.replace(
            ":activityId",
            activityId
          )}`
        )
          .then(({ data }) => {
            commit(mutation.SET_CALENDAR_ACTIVITY, data)
            if (data.playerActivityInfo.type === "INDIVIDUAL") {
              dispatch(action.FETCH_TIMELINE_CHART_DATA, {
                playerId: state.info.playerId,
                metric:
                  state.selectedMetric === "AP"
                    ? "AP_PERCENTAGE"
                    : state.selectedMetric,
                toDate: moment(state.info.ended).format("YYYY-MM-DD"),
              })
            }
            return resolve(data)
          })
          .catch((error) => {
            if (error && error.status && error.status.code === "BP_403") {
              commit(mutation.CALENDAR_ACTIVITY_NOT_FOUND)
            }
            if (error && error.status && error.status.code === "BP_404") {
              commit(mutation.CALENDAR_ACTIVITY_DELETED)
            }

            return reject(error)
          })
      }
    })
  },
  [action.CHANGE_CALENDAR_ACTIVITY_METRIC](
    { commit, state, dispatch },
    payload
  ) {
    if (!state.statsSegment[payload].length) {
      dispatch(action.FETCH_ACTIVITY_SELECTIONS, {
        activityId: state.playerActivityId,
        metricsType: payload,
      })
    }
    commit(mutation.UPDATE_CALENDAR_ACTIVITY_METRIC, payload)
  },
  [action.CHANGE_HR_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_HR_SELECTED_UNIT, payload)
  },
  [action.CACHE_DASHBOARD_ACTIVITY_DATA]({ commit }, payload) {
    commit(mutation.SET_CALENDAR_ACTIVITY, payload)
  },
  [action.CHANGE_AVG_HR_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_AVG_HR_SELECTED_UNIT, payload)
  },
  [action.CHANGE_TOP_HR_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_TOP_HR_SELECTED_UNIT, payload)
  },
  [action.CHANGE_AP_ZONES_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_AP_ZONES_SELECTED_UNIT, payload)
  },
  [action.CHANGE_WORKLOAD_ZONES_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_WORKLOAD_ZONES_SELECTED_UNIT, payload)
  },
  [action.CHANGE_DISTANCE_ZONES_SELECTED_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_DISTANCE_ZONES_SELECTED_UNIT, payload)
  },
  [action.CHANGE_HR_CHART_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_HR_CHART_UNIT, payload)
  },
  [action.CHANGE_DISTANCE_CHART_UNIT]({ commit }, payload) {
    commit(mutation.UPDATE_DISTANCE_CHART_UNIT, payload)
  },
  [action.CHANGE_ACTIVITY_DESCRIPTION](
    { commit },
    { activityId, description }
  ) {
    return new Promise((resolve, reject) => {
      ApiService.putData(
        `${CHANGE_ACTIVITY_DESCRIPTION_URL.replace(":activityId", activityId)}`,
        description,
        "text/plain"
      )
        .then(({ data }) => {
          commit(mutation.UPDATE_ACTIVITY_DESCRIPTION, description)
          resolve(description)
        })
        .catch((error) => reject(error))
    })
  },
  [action.DELETE_ACTIVITY]({ commit }, { activityId }) {
    return new Promise((resolve, reject) => {
      ApiService.delete(
        `${DELETE_ACTIVITY_SESSION_URL.replace(":activityId", activityId)}`
      )
        .then(({ data }) => {
          commit(mutation.DELETE_ACTIVITY, activityId)
          resolve(data)
        })
        .catch((error) => reject(error))
    })
  },
  [action.DESTROY_ACTIVITY_DATA]({ commit }) {
    commit(mutation.DESTROY_ACTIVITY_DATA)
  },
  [action.FETCH_ACTIVITY_SELECTIONS]({ commit }, { activityId, metricsType }) {
    return new Promise((resolve, reject) => {
      let metricsTypeParams = metricsType

      if (metricsType === SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR) {
        metricsTypeParams = SEGMENT_METRICS.HR
      }

      if (metricsType === SESSION_METRICS.WORKLOAD) {
        metricsTypeParams = SEGMENT_METRICS.WORKLOAD
      }

      ApiService.get(
        `${GET_ACTIVITY_SEGMENTS_URL.replace(":activityId", activityId)}`,
        {
          metricsType: metricsTypeParams,
        }
      )
        .then(({ data }) => {
          commit(mutation.UPDATE_ACTIVITY_SELECTIONS, { data, metricsType })
          resolve(data)
        })
        .catch((error) => reject(error))
    })
  },
  [action.CREATE_ACTIVITY_SEGMENT](
    { commit },
    { activityId, data, metricsType }
  ) {
    return new Promise((resolve, reject) => {
      let metricTypeData = "HR"
      switch (metricsType) {
        case SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR:
          metricTypeData = "HR"
          break
        case SESSION_METRICS.AP:
          metricTypeData = "AP"
          break
        case SESSION_METRICS.DISTANCE:
          metricTypeData = "DISTANCE"
          break
        case SESSION_METRICS.WORKLOAD:
          metricTypeData = "WORKLOAD"
          break
      }

      ApiService.post(
        `${CREATE_ACTIVITY_SEGMENTS_URL.replace(
          ":activityId",
          activityId
        ).replace(":metricsType", metricTypeData)}`,
        data
      )
        .then(({ data }) => {
          commit(mutation.ADD_ACTIVITY_SEGMENT, { data, metricsType })
          resolve(data)
        })
        .catch((error) => reject(error))
    })
  },
  [action.DELETE_ACTIVITY_SEGMENT]({ commit }, { activityId, segmentId }) {
    return new Promise((resolve, reject) => {
      ApiService.delete(
        `${DELETE_ACTIVITY_SEGMENTS_URL.replace(
          ":activityId",
          activityId
        ).replace(":segmentId", segmentId)}`
      )
        .then(({ data }) => {
          commit(mutation.DELETE_ACTIVITY_SEGMENT, segmentId)
          resolve(data)
        })
        .catch((error) => reject(error))
    })
  },
  [action.REMOVE_FROM_FILTERED_SEGMENT]({ commit }, { segmentId }) {
    commit(mutation.REMOVE_FROM_FILTERED_SEGMENT, segmentId)
  },
  [action.ADD_TO_FILTERED_SEGMENT]({ commit }, { segment }) {
    commit(mutation.ADD_TO_FILTERED_SEGMENT, segment)
  },
  [action.SELECT_DESELECT_ALL_SEGMENT]({ commit }, isSelectingAll) {
    commit(mutation.SELECT_DESELECT_ALL_SEGMENT, isSelectingAll)
  },
  [action.FETCH_STATS_TABLE_SEGMENTS](
    { commit },
    { metricsType, activityId, segmentId }
  ) {
    let metricTypeData

    switch (metricsType) {
      case SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR:
        metricTypeData = "HR"
        break
      case SESSION_METRICS.AP:
        metricTypeData = "AP"
        break
      case SESSION_METRICS.DISTANCE:
        metricTypeData = "DISTANCE"
        break
      case SESSION_METRICS.WORKLOAD:
        metricTypeData = "WORKLOAD"
        break
    }

    return new Promise((resolve, reject) => {
      ApiService.get(
        `${GET_SEGMENTS_STATS_TABLE_URL.replace(":activityId", activityId)}`,
        { metricsType: metricTypeData }
      )
        .then(({ data }) => {
          commit(mutation.UPDATE_LIST_OF_STATS_SEGMENTS, { data, metricsType })
          resolve(data)
        })
        .catch((error) => reject(error))
    })
  },
  [action.FETCH_MORE_PRECISE_ACTIVITY_DATA](
    { commit },
    {
      activityId,
      startOffsetSeconds,
      endOffsetSeconds,
      timeInterval,
      chartMetricsType,
    }
  ) {
    return new Promise((resolve, reject) => {
      ApiService.get(
        `${GET_MORE_PRECISE_ACTIVITY_DATA_URL.replace(
          ":activityId",
          activityId
        )}`,
        {
          startOffsetSeconds,
          endOffsetSeconds,
          timeInterval,
          chartMetricsType,
        }
      )
        .then(({ data }) => {
          commit(mutation.UPDATE_MORE_PRECISE_ACTIVITY_DATA, {
            data,
            selection: [startOffsetSeconds, endOffsetSeconds],
            chartMetricsType,
          })
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  [action.FETCH_TIMELINE_CHART_DATA]({ commit }, { playerId, metric, toDate }) {
    // TO DO: Check and compare parameters with BE side
    // return new Promise((resolve, reject) => {
      // ApiService.get(
      //   `${GET_TIMELINE_CHART_DATA_URL.replace(":playerId", playerId)}`,
      //   { metric, toDate }
      // )
      //   .then((data) => {
      //     commit(mutation.FETCH_TIMELINE_CHART_DATA, data.data)
      //     resolve(data)
      //   })
      //   .catch((error) => reject(error))
    // })
  },
}

const mutations = {
  [mutation.FETCH_TIMELINE_CHART_DATA](state, payload) {
    if (state.selectedMetric === METRICS.TIME_ABOVE_80_PERCENT_HR) {
      state.timelineChartData = payload
        .map((t) => {
          if (t.value !== null) {
            t.value = Math.floor(t.value / 60)
          }

          if (t.points && t.points.length) {
            t.points.map((p) => {
              if (p.value !== null) {
                p.value = Math.floor(p.value / 60)
              }
            })
          }

          return t
        })
        .sort((a, b) => new Date(a.date) - new Date(b.date))
    } else {
      // todo
      state.timelineChartData = payload.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      )
    }
  },
  [mutation.SET_CALENDAR_ACTIVITY](state, payload) {
    state.info = payload.playerActivityInfo
    state.summary = payload.playerActivitySummary
    state.playerActivityId = payload.playerActivityId
    state.stats = {
      [SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR]: payload.activityHrStats,
      [SESSION_METRICS.AP]: payload.activityAPStats,
      [SESSION_METRICS.DISTANCE]: payload.activityDistanceStats,
      [SESSION_METRICS.WORKLOAD]: payload.activityWorkloadStats,
    }
    state.dataFetchedSuccessfully = true
    state.segments = _.sortBy(payload.activitySegments, ["startPoint"])
    state.filteredSegments = _.sortBy(payload.activitySegments, ["startPoint"])
    state.statsSegment[SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR] = _.sortBy(
      payload.activitySegments,
      ["startPoint"]
    )

    const activityCached = state.cachedActivities.filter(
      (activity) => activity.playerActivityId === payload.playerActivityId
    ).length

    if (!activityCached) {
      if (state.cachedActivities.length > 50) {
        state.cachedActivities.unshift(payload)
        state.cachedActivities.pop()
      } else {
        state.cachedActivities.push(payload)
      }
    }
  },
  [mutation.UPDATE_CALENDAR_ACTIVITY_METRIC](state, payload) {
    state.selectedMetric = payload
  },
  [mutation.UPDATE_HR_SELECTED_UNIT](state, payload) {
    state.hrSelectedUnit = payload
  },
  [mutation.UPDATE_AVG_HR_SELECTED_UNIT](state, payload) {
    state.avgHrSelectedUnit = payload
  },
  [mutation.UPDATE_TOP_HR_SELECTED_UNIT](state, payload) {
    state.topHrSelectedUnit = payload
  },
  [mutation.UPDATE_AP_ZONES_SELECTED_UNIT](state, payload) {
    state.apZonesSelectedUnit = payload
  },
  [mutation.UPDATE_WORKLOAD_ZONES_SELECTED_UNIT](state, payload) {
    state.workloadZonesSelectedUnit = payload
  },
  [mutation.UPDATE_DISTANCE_ZONES_SELECTED_UNIT](state, payload) {
    state.distanceZonesSelectedUnit = payload
  },
  [mutation.UPDATE_HR_CHART_UNIT](state, payload) {
    state.hrChartUnit = payload
  },
  [mutation.UPDATE_DISTANCE_CHART_UNIT](state, payload) {
    state.distanceChartUnit = payload
  },
  [mutation.UPDATE_ACTIVITY_ATTACHMENTS](state, payload) {
    state.info.attachments.unshift(payload)
  },
  [mutation.UPDATE_ACTIVITY_DESCRIPTION](state, payload) {
    state.info.description = payload
  },
  [mutation.DELETE_ACTIVITY_ATTACHMENT](state, deletedAttachmentId) {
    state.info.attachments = state.info.attachments.filter(
      (a) => a.id !== deletedAttachmentId
    )
  },
  [mutation.DELETE_ACTIVITY](state, activityId) {
    state.cachedActivities = state.cachedActivities.filter(
      (activity) => activity.playerActivityId !== activityId
    )
    state.activityDeleted = true
  },
  [mutation.DESTROY_ACTIVITY_DATA](state) {
    Object.assign(state, getDefaultState())
  },
  [mutation.UPDATE_ACTIVITY_SELECTIONS](state, { data, metricsType }) {
    state.statsSegment[metricsType] = _.sortBy(data, ["startPoint"])
  },
  [mutation.ADD_ACTIVITY_SEGMENT](state, { data, metricsType }) {
    state.segments.push(data)
    state.filteredSegments.push(data)
    state.segments = _.sortBy(state.segments, ["startPoint"])
    state.filteredSegments = _.sortBy(state.filteredSegments, ["startPoint"])

    if (
      metricsType === SESSION_METRICS.DISTANCE ||
      metricsType === SESSION_METRICS.WORKLOAD
    ) {
      state.statsSegment[SESSION_METRICS.DISTANCE].push(data)
      state.statsSegment[SESSION_METRICS.WORKLOAD].push(data)

      state.statsSegment[SESSION_METRICS.DISTANCE] = _.sortBy(
        state.statsSegment[SESSION_METRICS.DISTANCE],
        ["startPoint"]
      )
      state.statsSegment[SESSION_METRICS.WORKLOAD] = _.sortBy(
        state.statsSegment[SESSION_METRICS.WORKLOAD],
        ["startPoint"]
      )
    } else {
      state.statsSegment[metricsType].push(data)
      state.statsSegment[metricsType] = _.sortBy(
        state.statsSegment[metricsType],
        ["startPoint"]
      )
    }

    for (let metric in state.statsSegment) {
      if (metric !== metricsType) {
        if (
          metricsType === SESSION_METRICS.DISTANCE ||
          metricsType === SESSION_METRICS.WORKLOAD
        ) {
          if (
            metric !== SESSION_METRICS.DISTANCE &&
            metric !== SESSION_METRICS.WORKLOAD
          ) {
            state.statsSegment[metric] = []
          }
        } else {
          state.statsSegment[metric] = []
        }
      }
    }
  },
  [mutation.DELETE_ACTIVITY_SEGMENT](state, segmentId) {
    state.segments = state.segments.filter((s) => s.id !== segmentId)
    state.filteredSegments = state.filteredSegments.filter(
      (s) => s.id !== segmentId
    )
    state.segments = _.sortBy(state.segments, ["startPoint"])
    state.filteredSegments = _.sortBy(state.filteredSegments, ["startPoint"])

    for (var metric in state.statsSegment) {
      state.statsSegment[metric] = state.statsSegment[metric].filter(
        (s) => s.id !== segmentId
      )
    }
  },
  [mutation.ADD_TO_FILTERED_SEGMENT](state, segment) {
    state.filteredSegments.push(segment)
  },
  [mutation.REMOVE_FROM_FILTERED_SEGMENT](state, segmentId) {
    state.filteredSegments = state.filteredSegments.filter(
      (s) => s.id !== segmentId
    )
  },
  [mutation.SELECT_DESELECT_ALL_SEGMENT](state, isSelectingAll) {
    if (isSelectingAll) {
      state.filteredSegments = _.clone(state.segments)
    } else {
      state.filteredSegments = []
    }
  },
  [mutation.UPDATE_LIST_OF_STATS_SEGMENTS](state, { data, metricsType }) {
    state.statsSegment[metricsType] = _.sortBy(data, ["startPoint"])
  },
  [mutation.CALENDAR_ACTIVITY_NOT_FOUND](state) {
    state.activityNotFound = true
  },
  [mutation.CALENDAR_ACTIVITY_DELETED](state) {
    state.activityDeleted = true
  },
  [mutation.UPDATE_MORE_PRECISE_ACTIVITY_DATA](
    state,
    { data, selection, chartMetricsType }
  ) {
    const selectionScope = (selection[1] - selection[0]) / 60
    const detailedData = {}

    if (selectionScope < 5) {
      for (let i = selection[0], j = 0; i < selection[1]; i += 2, j++) {
        if (data[j]) {
          detailedData[i] = data[j]
        }
      }

      if (chartMetricsType === "HR_PERCENTAGE") {
        const temp = Object.assign(
          state.highestPreciseChartDataHrPercentage,
          detailedData
        )

        state.highestPreciseChartDataHrPercentage = Object.assign({}, temp)
      } else if (chartMetricsType === "HR_BPM") {
        const temp = Object.assign(
          state.highestPreciseChartDataHrBPM,
          detailedData
        )

        state.highestPreciseChartDataHrBPM = Object.assign({}, temp)
      } else {
        const temp = Object.assign(
          state.highestPreciseChartDataAP,
          detailedData
        )

        state.highestPreciseChartDataAP = Object.assign({}, temp)
      }
    } else if (selectionScope < 15) {
      for (let i = selection[0], j = 0; i < selection[1]; i += 10, j++) {
        if (data[j]) {
          detailedData[i] = data[j]
        }
      }

      if (chartMetricsType === "HR_PERCENTAGE") {
        const temp = Object.assign(
          state.highPreciseChartDataHrPercentage,
          detailedData
        )

        state.highPreciseChartDataHrPercentage = Object.assign({}, temp)
      } else if (chartMetricsType === "HR_BPM") {
        const temp = Object.assign(
          state.highPreciseChartDataHrBPM,
          detailedData
        )

        state.highPreciseChartDataHrBPM = Object.assign({}, temp)
      } else {
        const temp = Object.assign(state.highPreciseChartDataAP, detailedData)

        state.highPreciseChartDataAP = Object.assign({}, temp)
      }
    } else if (selectionScope < 30) {
      for (let i = selection[0], j = 0; i < selection[1]; i += 30, j++) {
        if (data[j]) {
          detailedData[i] = data[j]
        }
      }

      if (chartMetricsType === "HR_PERCENTAGE") {
        const temp = Object.assign(
          state.mediumPreciseChartDataHrPercentage,
          detailedData
        )

        state.mediumPreciseChartDataHrPercentage = Object.assign({}, temp)
      } else if (chartMetricsType === "HR_BPM") {
        const temp = Object.assign(
          state.mediumPreciseChartDataHrBPM,
          detailedData
        )

        state.mediumPreciseChartDataHrBPM = Object.assign({}, temp)
      } else {
        const temp = Object.assign(state.mediumPreciseChartDataAP, detailedData)

        state.mediumPreciseChartDataAP = Object.assign({}, temp)
      }
    }

    // if(selectionScope < 30 && selectionScope > 15) {
    //   for(let i = selection[0], j = 0; i < selection[1]; i+=30, j++) {
    //     if(data[j]) {
    //       detailedData[i] = data[j];
    //     }
    //   }

    //   if(chartMetricsType === 'HR_PERCENTAGE') {
    //     const temp = Object.assign(state.mediumPreciseChartDataHrPercentage, detailedData);

    //     state.mediumPreciseChartDataHrPercentage = Object.assign({}, temp);

    //   } else if (chartMetricsType === 'HR_BPM') {
    //     const temp = Object.assign(state.mediumPreciseChartDataHrBPM, detailedData);

    //     state.mediumPreciseChartDataHrBPM = Object.assign({}, temp);
    //   } else {
    //     const temp = Object.assign(state.mediumPreciseChartDataAP, detailedData);

    //     state.mediumPreciseChartDataAP = Object.assign({}, temp);
    //   }

    // } else if (selectionScope < 15) {

    //   for(let i = selection[0], j = 0; i < selection[1]; i+=2, j++) {
    //     if(data[j]) {
    //       detailedData[i] = data[j];
    //     }
    //   }

    //   if(chartMetricsType === 'HR_PERCENTAGE') {
    //     const temp = Object.assign(state.highPreciseChartDataHrPercentage, detailedData);

    //     state.highPreciseChartDataHrPercentage = Object.assign({}, temp);
    //   } else if (chartMetricsType === 'HR_BPM') {
    //     const temp = Object.assign(state.highPreciseChartDataHrBPM, detailedData);

    //     state.highPreciseChartDataHrBPM = Object.assign({}, temp);
    //   } else {
    //     const temp = Object.assign(state.highPreciseChartDataAP, detailedData);

    //     state.highPreciseChartDataAP = Object.assign({}, temp);
    //   }
    // }
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
